export default __webpack_public_path__ + "static/media/BlackBrickWithFadeDownAndLogo.5d157af5.png";